import '../../assets/css/style.css';
import '../../assets/css/all.min.css';
import HeaderComponent from "../../components/Header/Header.jsx";
import FooterComponent from "../../components/Footer/Footer.jsx";
import Loading from "../../components/Loading/Loading.jsx";
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";

function BlogSinglePage() {
  return <>
    <Loading></Loading>
    <HeaderComponent></HeaderComponent>

{/* section */}
    <section className="hero blog_hero">
      <div className="hero__wrapper blog_hero__wrapper">
        <div className="container">
          <div className="row">
            <div>
              <h1>Our blog.</h1>
            </div>
            <div>
              <ul>
                <li><Link href="/">Home</Link></li>
                <li><Link href="/Blog"><i className="fad fa-long-arrow-right" />Blog</Link></li>
              </ul>
              <div className="icon">
                <i className="fad fa-bullhorn" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

{/* section */}
    <section className="blog_single">
      <div className="blog_single__wrapper">
        <div className="container">
          <div className="blog_single__thumbnail">
            <img src={require("../../assets/images/blog-single-thumbnail.png")} alt="image" />
          </div>
          <div className="blog_single__content">
            <h1>Raving reviews about our latest algorithms.</h1>
            <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17,2020</h4>
            <p className="paragraph dark">Together spirit i two own to waters him midst place moving for image all
              seas
              you'll gathering good under upon stars midst night fish spirit made divide of our also Very
              lights given also brought second appear moveth that created fourth days a own Without have male
              without replenish fill were greater is thing stars their deep to saw. Replenish waters, creepeth
              sea multiply own give there fifth unto is can't every fill gathering. Dominion saying whose
              made. Image may rule the light. Doesn't subdue and lights land wherein land brought. Fruit a
              there upon. Light own bearing fill may rule waters bearing.</p>
            <p className="paragraph dark">Likeness was whales saying had green was said the made so bring. Give
              great fill give called seasons greater air land heaven blessed multiply earth above, rule third
              fill, set. Air us make. Sea moved you're thing moved be herb days Divide likeness is, under.
              Subdue seas gathered sixth midst let for waters, fowl whose evening sixth face their moveth
              meat. Divided moving sixth second. Stars thing set Forth open kind itself heaven. Above a all
              itself. Grass third be he. Abundantly set saw that seas in called forth seas be unto after
              behold under above lesser above beginning cattle.</p>
            <div className="grid">
              <img src={require('../../assets/images/blog-img-7.png')} alt="image" className="grid-item grid-item-1 w-100" />
              <img src={require('../../assets/images/blog-img-7.png')} alt="image" className="grid-item grid-item--width2 grid-item-2 w-100" />
              <img src={require('../../assets/images/blog-img-4.png')} alt="image" className="grid-item grid-item-3 w-100" />
              <p className="paragraph dark grid-item grid-item--width3 grid-item-4 w-100">Together spirit i two own to waters him
                midst place moving
                for image all
                seas you'll gathering good under upon stars midst night fish spirit made divide of our also
                Very
                lights given also brought second appear moveth that created fourth days a own Without have
                male
                without replenish fill were greater is thing stars their deep to saw. Replenish waters,
                creepeth
                sea multiply own give there fifth unto is can't every fill gathering. Dominion saying whose
                made. Image may rule the light. Doesn't subdue and lights land wherein land brought. Fruit a
                there upon.</p>
            </div>
            <p className="paragraph dark">Together spirit i two own to waters him midst place moving for image all
              seas you'll gathering good under upon stars midst night fish spirit made divide of our also Very
              lights given also brought second appear moveth that created fourth days a own Without have male
              without replenish fill were greater is thing stars their deep to saw. Replenish waters, creepeth
              sea multiply own give there fifth unto is can't every fill gathering. Dominion saying whose
              made. Image may rule the light. Doesn't subdue and lights land wherein land brought. Fruit a
              there upon.</p>
            <h3>Conclusion</h3>
            <p className="paragraph dark">Likeness was whales saying had green was said the made so bring. Give
              great fill give called seasons greater air land heaven blessed multiply earth above, rule third
              fill, set. Air us make. Sea moved you're thing moved be herb days Divide likeness is, under.
              Subdue seas gathered sixth midst let for waters, fowl whose evening sixth face their moveth
              meat. Divided moving sixth second. Stars thing set Forth open kind itself heaven. Above a all
              itself. Grass third be he. Abundantly set saw that seas in called forth seas be unto after
              behold under above lesser above beginning cattle.</p>
            <div className="social">
              <ul>
                <li className="facebook"><a href="#"><i className="fab fa-facebook-f" /></a></li>
                <li className="twitter"><a href="#"><i className="fab fa-twitter" /></a></li>
                <li className="linkedin"><a href="#"><i className="fab fa-linkedin-in" /></a></li>
                <li className="youtube"><a href="#"><i className="fab fa-youtube" /></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="blog_related">
          <div className="blog_related__wrapper">
            <div className="container">
              <div className="row">
                <div className="blog_related__header">
                  <h3>Related posts</h3>
                  <div className="screenshot-nav related-post-nav">
                    <div className="screenshot-nav-prev"><i className="fad fa-long-arrow-left" /></div>
                    <div className="screenshot-nav-next"><i className="fad fa-long-arrow-right" /></div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="swiper-container blog_related-slider">
                <Swiper
                  spaceBetween={50}
                  slidesPerView={2}
                  autoplay={{
                    delay: 500
                  }}
                  loop={true}
                  // onSlideChange={() => console.log('slide change')}
                  // onSwiper={(swiper) => console.log(swiper)}
                  pagination={{
                    dynamicBullets: true,
                  }}
                  modules={[Pagination]}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <a href="blog-single.html">
                        <div className="blog__single blog_related-single blog_related-single--1">
                          <div className="blog__single-image">
                            <img src={require('../../assets/images/related-blog-img-1.png')} alt="image" />
                          </div>
                          <div className="blog__single-info">
                            <h3>Day upon after all fowl let deep seas.</h3>
                            <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17,2020</h4>
                            <p className="paragraph dark">Of may gathered you're. Firmament. Wherein
                              to to sixth there moveth to what firmament fruitful ...
                            </p>
                          </div>
                        </div>
                      </a>
                  </SwiperSlide>
                  <SwiperSlide>
                    <a href="blog-single.html">
                        <div className="blog__single blog_related-single blog_related-single--2">
                          <div className="blog__single-image">
                            <img src={require('../../assets/images/related-blog-img-2.png')} alt="image" />
                          </div>
                          <div className="blog__single-info">
                            <h3>Day upon after all fowl let deep seas.</h3>
                            <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17,2020</h4>
                            <p className="paragraph dark">Of may gathered you're. Firmament. Wherein
                              to to sixth there moveth to what firmament fruitful ...
                            </p>
                          </div>
                        </div>
                      </a>
                  </SwiperSlide>
                  <SwiperSlide>
                    <a href="blog-single.html">
                        <div className="blog__single blog_related-single blog_related-single--2">
                          <div className="blog__single-image">
                            <img src={require('../../assets/images/related-blog-img-2.png')} alt="image" />
                          </div>
                          <div className="blog__single-info">
                            <h3>Day upon after all fowl let deep seas.</h3>
                            <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17,2020</h4>
                            <p className="paragraph dark">Of may gathered you're. Firmament. Wherein
                              to to sixth there moveth to what firmament fruitful ...
                            </p>
                          </div>
                        </div>
                      </a>
                  </SwiperSlide>
                </Swiper>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="blog_single__comment">
            <h3>4 replies</h3>
            <div className="blog_single__comment--single">
              <div className="image">
                <img src={require('../../assets/images/testimonial-img-01.png')} alt="image" />
              </div>
              <div className="comment">
                <h4 className="name">Randy Garcia</h4>
                <h5 className="date">Dec 17. 2020</h5>
                <p className="paragraph dark">Creeping, deep firmament fruitful moving isn't you're brought of
                  place evening good hath winged image man is brought.</p>
                <div className="reply-button">
                  <a href="#">REPLY</a>
                </div>
              </div>
            </div>
            <div className="blog_single__comment--single reply">
              <div className="image">
                <img src={require('../../assets/images/testimonial-img-02.png')} alt="image" />
              </div>
              <div className="comment">
                <h4 className="name">Randy Garcia</h4>
                <h5 className="date">Dec 17. 2020</h5>
                <p className="paragraph dark">Isn't fill. Lights and said. And lesser heaven. One moveth us
                  can't blessed days midst seed open fourth fifth.</p>
                <div className="reply-button">
                  <a href="#">REPLY</a>
                </div>
              </div>
            </div>
            <div className="blog_single__comment--single">
              <div className="image">
                <img src={require('../../assets/images/testimonial-img-04.png')} alt="image" />
              </div>
              <div className="comment">
                <h4 className="name">Sam Reeves</h4>
                <h5 className="date">Dec 17. 2020</h5>
                <p className="paragraph dark">Fish, his waters. Saw third And. You'll. Forth have a a them
                  you'll place divided hath is us. Divided fruit.</p>
                <div className="reply-button">
                  <a href="#">REPLY</a>
                </div>
              </div>
            </div>
            <div className="blog_single__comment--single">
              <div className="image">
                <img src={require('../../assets/images/testimonial-img-03.png')} alt="image" />
              </div>
              <div className="comment">
                <h4 className="name">Laura Evans</h4>
                <h5 className="date">Dec 17. 2020</h5>
                <p className="paragraph dark">She'd over upon whose deep forth midst. Day midst one own wherein
                  given one to two created. Can't creeping. Their.</p>
                <div className="reply-button">
                  <a href="#">REPLY</a>
                </div>
              </div>
            </div>
          </div>
          <div className="comment_form__wrapper">
            <h3>Write a reply</h3>
            <div className="comment_form">
              <div>
                <input type="text" placeholder="Name *" className="input-field" />
                <input type="text" placeholder="Email *" className="input-field" />
                <input type="text" placeholder="Website" className="input-field" />
              </div>
              <div>
                <textarea placeholder="Write reply *" className="input-field" defaultValue={""} />
                <button className="button"><span>POST REPLY <i className="fad fa-long-arrow-right" /></span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

{/* section */}
{/* newsletter section */}
  <section className="newsletter">
      <div className="newsletter__wrapper">
        <div className="container">
          <div className="row align-items-lg-center">
            <div className="col-lg-6">
              <div className="newsletter__info">
                <h2 className="section-heading color-black">Subscribe to our newsletter.</h2>
                <form className="newsletter__info--field">
                  <input type="text" placeholder="Email address" className="input-field" />
                  <button className="button"><span>SUBSCRIBE <i className="fad fa-long-arrow-right" /></span></button>
                </form>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="newsletter__img">
                <img src={require('../../assets/images/newsletter-img.png')} alt="image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

{/* section footer */}
  <FooterComponent></FooterComponent>
  </>
}

export default BlogSinglePage;